import { render, staticRenderFns } from "./PptToWord.vue?vue&type=template&id=42d3b6bb&scoped=true"
import script from "./PptToWord.vue?vue&type=script&lang=js"
export * from "./PptToWord.vue?vue&type=script&lang=js"
import style0 from "./PptToWord.vue?vue&type=style&index=0&id=42d3b6bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d3b6bb",
  null
  
)

export default component.exports